import { useStore } from '@nanostores/react'
import React from 'react'

import { Dialog } from '@/components/Dialog'
import { LinkButton } from '@/components/Link/LinkButton'
import { RichTextBlock } from '@/components/Sections/SectionRichText/RichTextBlock'
import { $openedDialog } from '@/stores/dialog/computed'
import { closeDialog } from '@/stores/dialog/actions'
import {
  PortableText,
  type PortableTextReactComponents,
} from '@portabletext/react'
import type { CMSButtonLink, CMSProgramInfoModal } from '@/types/sanity'

import styles from './AdditionalInfoDialog.module.scss'

type Props = Pick<CMSProgramInfoModal, 'header' | 'body' | 'ctas'>

const portableTextComponents: Partial<PortableTextReactComponents> = {
  block: RichTextBlock,
}

export const AdditionalInfoDialog: React.FC<Props> = ({
  header,
  body,
  ctas,
}) => {
  const openedDialog = useStore($openedDialog)
  const isOpen = openedDialog?.id === 'program-info-modal'

  const handleCtaClick = ({
    event,
    cta,
  }: {
    event: React.MouseEvent<HTMLAnchorElement>
    cta: CMSButtonLink
  }) => {
    if (cta.url === '#') {
      event.preventDefault()
    }

    closeDialog()
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={closeDialog}
      className={styles.dialogContainer}
    >
      <div className={styles.innerContainer}>
        {header && <div className={styles.header}>{header}</div>}
        {body && (
          <div className={styles.body}>
            <PortableText value={body} components={portableTextComponents} />
          </div>
        )}
        {ctas?.length && (
          <div className={styles.ctas}>
            {ctas.map((cta, index) => (
              <LinkButton
                key={index}
                link={cta}
                onClick={(event) => handleCtaClick({ event, cta })}
              />
            ))}
          </div>
        )}
      </div>
    </Dialog>
  )
}
